import React, { useRef } from "react";
import { gsap } from "../../lib/gsap";
import profile from "../../data/profile";

export default function ScreenLoader({ onDismiss }) {
  const overlayRef = useRef(null);

  function handleStart() {
    // Unmute + play intro video with sound (must run in user gesture)
    const introVideo = document.querySelector('[data-testid="intro-video"]');
    if (introVideo) {
      try {
        introVideo.currentTime = 0;
        introVideo.muted = false;
        introVideo.play().catch(() => {});
      } catch (e) {}
    }
    window.dispatchEvent(new CustomEvent("loader-dismissed"));

    const overlay = overlayRef.current;
    if (!overlay) return;
    overlay.style.pointerEvents = "none";

    const top = document.createElement("div");
    Object.assign(top.style, {
      position: "fixed", top: 0, left: 0, right: 0, height: "50vh",
      background: "var(--ink)", zIndex: 9998,
    });
    const bottom = document.createElement("div");
    Object.assign(bottom.style, {
      position: "fixed", bottom: 0, left: 0, right: 0, height: "50vh",
      background: "var(--ink)", zIndex: 9998,
    });
    const line = document.createElement("div");
    Object.assign(line.style, {
      position: "fixed", top: "50%", left: 0, right: 0, height: "1px",
      background: "var(--accent)", boxShadow: "0 0 20px var(--accent)", zIndex: 9999,
      transform: "scaleX(0)", transformOrigin: "center",
    });
    document.body.appendChild(top);
    document.body.appendChild(bottom);
    document.body.appendChild(line);

    gsap.to(overlay, { opacity: 0, duration: 0.25 });
    gsap.to(line, { scaleX: 1, duration: 0.35, ease: "power2.out" });
    gsap.to(top, { y: "-100%", duration: 1.0, ease: "expo.inOut" });
    gsap.to(bottom, { y: "100%", duration: 1.0, ease: "expo.inOut" });
    gsap.to(line, { opacity: 0, duration: 0.35, delay: 0.35 });

    setTimeout(() => {
      top.remove(); bottom.remove(); line.remove();
      onDismiss();
    }, 1050);
  }

  return (
    <div ref={overlayRef} data-testid="screen-loader"
      className="fixed inset-0 z-[9997] flex flex-col items-center justify-center gap-8"
      style={{ background: "var(--ink)" }}>
      <div className="absolute inset-0 opacity-20 pointer-events-none"
        style={{
          background: "radial-gradient(circle at 30% 20%, rgba(212,162,76,0.35), transparent 40%), radial-gradient(circle at 70% 80%, rgba(176,137,74,0.25), transparent 40%)",
          filter: "blur(80px)",
        }} />
      <p className="font-serif italic text-3xl md:text-4xl text-[var(--paper)] tracking-tight">
        {profile.name.full}
      </p>
      <p className="font-mono text-[10px] tracking-[0.4em] uppercase text-[var(--accent)]">&nbsp;</p>
      <p className="text-xs text-[color:rgba(245,242,236,0.55)] max-w-xs text-center px-6">
        Enter to unlock the intro with sound.
      </p>
      <button onClick={handleStart} data-testid="loader-start"
        className="mt-2 px-8 py-3 rounded-full border border-[var(--accent)] text-[var(--accent)] font-mono text-xs tracking-[0.3em] uppercase hover:bg-[var(--accent)] hover:text-[var(--ink)] transition">
        Enter with sound
      </button>
    </div>
  );
}
